const JoinGroupFailureMessage = {
    "noauth": "Something went wrong. Try again, or get a new invitation link",
    "notoken": "Something went wrong. Try again, or get a new invitation link",
    "notfound": "Invitation not found. Try getting a new link.",
    "expired": "The invitation link you used has expired. Get a new invitation link and try again",
    "nogroup": "Something went wrong and we can't find that group. Get a new invite link and try again.",
    "isMember": "Looks like you're already a member of this group. No need to join again!",
    "error": "Something went wrong. Try again, or get a new invitation link"
}

export default JoinGroupFailureMessage;